export const accordeon = () => {

    const accordeon = document.querySelectorAll('.js-accordeon');

    if ( accordeon ) {
        for (let el of accordeon) {
          el.addEventListener('click',function(){
            //document.querySelector('.questions__accordeon_open')?.classList.remove("questions__accordeon_open");

            let height = el.querySelector('.questions__accordeon-in').offsetHeight;


            if ( el.classList.contains("questions__accordeon_open") ) {
                el.classList.remove("questions__accordeon_open");
                el.querySelector('.questions__accordeon-hidden').style.height = 0;
            } else {

                if ( document.querySelector('.questions__accordeon_open') ) {
                    document.querySelector('.questions__accordeon_open').querySelector('.questions__accordeon-hidden').style.height = 0;
                    document.querySelector('.questions__accordeon_open').classList.remove("questions__accordeon_open");
                }

                el.classList.add("questions__accordeon_open");
                el.querySelector('.questions__accordeon-hidden').style.height = height + 45 + "px";
            }
            
           

          });
        }
    }

}